import React, { useEffect, useState } from 'react';
import { listTemplates, createTemplate, deleteTemplate, applyTemplate } from '../../lib/reportStudioApi';
import { useClubIdentity } from '../../lib/useClubIdentity';
import ReportPreviewMock from './ReportPreviewMock';
import { Modal, Field, inputCls, PrimaryBtn } from '../../pages/organization/finance/shared';

export default function TemplatesSection({ canManage }) {
  const identity = useClubIdentity();
  const [templates, setTemplates] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [saveModal, setSaveModal] = useState(false);
  const [name, setName] = useState('');
  const [toast, setToast] = useState(null);
  const notify = (m) => { setToast(m); setTimeout(() => setToast(null), 2500); };

  const load = () => listTemplates().then((t) => { setTemplates(t); if (!activeId && t.length) setActiveId(t[0].id); });
  useEffect(() => { load(); }, []);

  const active = templates.find((t) => t.id === activeId);

  const doApply = async (t) => {
    try { await applyTemplate(t.id); notify(`تم تطبيق قالب «${t.name}» على الإعدادات العامة`); }
    catch { notify('فشل تطبيق القالب'); }
  };
  const doSave = async () => {
    if (!name.trim()) return;
    try { await createTemplate(name.trim()); setSaveModal(false); setName(''); notify('تم حفظ القالب'); load(); }
    catch { notify('فشل حفظ القالب'); }
  };
  const doDelete = async (t) => {
    try { await deleteTemplate(t.id); notify('تم حذف القالب'); load(); }
    catch { notify('تعذر حذف هذا القالب'); }
  };

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-[1.4fr_1fr]" data-testid="rs-templates-section">
      {toast && <div className="fixed top-16 left-1/2 z-50 -translate-x-1/2 rounded-lg bg-[#16233b] px-4 py-2 text-sm text-white shadow-lg">{toast}</div>}
      <div>
        {canManage && <div className="mb-3 flex justify-end"><PrimaryBtn onClick={() => setSaveModal(true)} data-testid="rs-save-template-btn">حفظ الإعدادات الحالية كقالب</PrimaryBtn></div>}
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {templates.map((t) => (
            <button key={t.id} onClick={() => setActiveId(t.id)} className={`rounded-xl border p-3 text-right ${activeId === t.id ? 'border-teal-400 bg-teal-50/40' : 'border-slate-200 bg-white'}`} data-testid={`rs-template-card-${t.id}`}>
              <div className="flex items-center justify-between">
                <span className="text-sm font-bold text-slate-800">{t.name}</span>
                <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${t.is_system ? 'bg-slate-100 text-slate-500' : 'bg-indigo-50 text-indigo-700'}`}>{t.is_system ? 'قالب نظام' : 'قالب خاص'}</span>
              </div>
              {canManage && (
                <div className="mt-2 flex gap-2">
                  <span onClick={(e) => { e.stopPropagation(); doApply(t); }} className="text-xs font-semibold text-teal-700 hover:underline" data-testid={`rs-template-apply-${t.id}`}>تطبيق كنقطة بداية</span>
                  {!t.is_system && <span onClick={(e) => { e.stopPropagation(); doDelete(t); }} className="text-xs font-semibold text-red-600 hover:underline" data-testid={`rs-template-delete-${t.id}`}>حذف</span>}
                </div>
              )}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className="mb-2 text-xs font-bold text-slate-500">معاينة القالب</p>
        {active ? <ReportPreviewMock settings={active.settings} identity={identity} reportTitle={active.name} /> : <div className="h-40 animate-pulse rounded-xl bg-slate-100" />}
      </div>

      <Modal open={saveModal} title="حفظ الإعدادات الحالية كقالب" onClose={() => setSaveModal(false)}>
        <Field label="اسم القالب" required><input className={inputCls} value={name} onChange={(e) => setName(e.target.value)} data-testid="rs-template-name-input" /></Field>
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={() => setSaveModal(false)} className="rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-600">إلغاء</button>
          <PrimaryBtn onClick={doSave} data-testid="rs-template-save-confirm">حفظ</PrimaryBtn>
        </div>
      </Modal>
    </div>
  );
}
